import { render, staticRenderFns } from "./FiltersDrawer.vue?vue&type=template&id=c8164e00&"
import script from "./FiltersDrawer.vue?vue&type=script&lang=ts&"
export * from "./FiltersDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersDrawer.vue?vue&type=style&index=0&id=c8164e00&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports